import { createSlice } from "@reduxjs/toolkit";
import { fetchProfitLoss } from "./ProfitLossThunk";

const initialState = {
  balances: {},
  appliedFilters: null,
  loading: false,
  filters: {
    filterType: "Date Wise",
    fromDate: null,
    toDate: null,
  },
};

const profitLossSlice = createSlice({
  name: "profitLoss",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfitLoss.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProfitLoss.fulfilled, (state, action) => {
        state.loading = false;
        state.balances = action.payload || {};
        state.appliedFilters = action.meta.arg?.filters || null;
      })
      .addCase(fetchProfitLoss.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = profitLossSlice.actions;
export default profitLossSlice.reducer;
